export const environment = {
  production: true,
  backendUrl: 'https://sauna360inc-api.gung.io/',
  projectName: 'tylo',
  siteTitle: 'Tylö Pro Shop',
  mainCountry: 'usa',
  copyToCartExcludedProductIds: ['00000023'],
  logoName: 'sauna360-logo.png'
};
